import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MemberEvaluationService } from '../../../../../app/members/member-evaluation.service';

@Component({
  selector: 'app-evaluation-introduction',
  templateUrl: './evaluation-introduction.component.html',
  styleUrls: ['./evaluation-introduction.component.scss'],
  standalone: false
})
export class EvaluationIntroductionComponent implements OnInit, OnDestroy {
  private _subscription: Subscription;

  introduction: string;

  onStartClicked() {
    this.service.starEvaluation();
  }

  constructor(private service: MemberEvaluationService) {}

  ngOnInit(): void {
    this._subscription = this.service.evaluation.subscribe((result) => {
      if (result) {
        this.introduction = result.introduction;
        this.service.setEvaluationForm();
      }
    });
  }

  ngOnDestroy(): void {
    if (this._subscription) this._subscription.unsubscribe();
  }
}
